import { useTranslation } from "react-i18next";
import { applyLanguage, normalizeLanguage } from "@/i18n";

// Employee Mobile language is device-local only (no account / backend storage).
export const EMPLOYEE_LANG_KEY = "miseone-employee-lang";

export function readEmployeeLanguage() {
    try {
        const v = localStorage.getItem(EMPLOYEE_LANG_KEY);
        return v ? normalizeLanguage(v) : null;
    } catch (_e) { return null; }
}

const OPTIONS = [
    { code: "en", label: "English" },
    { code: "fi", label: "Suomi" },
];

export function MobileLanguageSelector({ className = "" }) {
    const { i18n } = useTranslation();
    const current = i18n.language === "fi" ? "fi" : "en";
    const choose = (code) => {
        if (code === current) return;
        try { localStorage.setItem(EMPLOYEE_LANG_KEY, code); } catch (_e) { /* private mode */ }
        applyLanguage(code);
    };
    return (
        <div role="radiogroup" aria-label="Language / Kieli" data-testid="mobile-language-selector"
            className={`inline-flex rounded-full border border-neutral-300 bg-white/70 p-0.5 text-sm ${className}`}>
            {OPTIONS.map((o) => {
                const active = o.code === current;
                return (
                    <button key={o.code} type="button" role="radio" aria-checked={active} lang={o.code}
                        data-testid={`mobile-language-${o.code}`} onClick={() => choose(o.code)}
                        className={`min-h-[40px] min-w-[76px] px-3 rounded-full font-medium transition-colors ${
                            active ? "bg-neutral-900 text-white" : "text-neutral-700 active:bg-neutral-100"}`}>
                        {o.label}
                    </button>
                );
            })}
        </div>
    );
}
